import { Link } from 'react-router-dom';

// Shared header for /login, /signup, /reset cards (night theme).
// Text lockup instead of the PNG — the logo file has a white background box that
// reads as a sticker on the dark public design. Same brand treatment as the
// landing nav (GIRA + orange OPS, Barlow Condensed).

export default function AuthHeader() {
  return (
    <div className="auth-header">
      <Link to="/" className="lp3-authbrand" aria-label="Giraops home">
        GIRA<em>OPS</em>
      </Link>
      <Link to="/" className="auth-header-back">← Back to home</Link>
    </div>
  );
}
